/**
 * @param {string | null} email
 *
 * @returns {string | null}
 */
export const HrefMailTo = (email) => (email ? `mailto:${email}` : null);
